import styled from 'styled-components';

// ─── Botão gatilho (telas de UC) → navega para /integracoes ──────────────────

export const TriggerButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 18px;
  border-radius: 3px;
  border: 1px solid ${(props) => props.theme.color.ui.primary};
  background: ${(props) => props.theme.color.bg.primary};
  color: ${(props) => props.theme.color.ui.primary};
  font-family: ${(props) => props.theme.font.body.family};
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition: opacity 0.15s ease;

  svg {
    font-size: 16px;
  }
  &:hover {
    opacity: 0.85;
  }
`;

// ─── Endereço de recebimento (card estático) ─────────────────────────────────

export const AliasBox = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 14px;
  border-radius: 3px;
  background-color: ${(props) => props.theme.color.bg.muted};
  border: 1px dashed ${(props) => props.theme.color.ui.shade2};

  code {
    font-family: 'Courier New', monospace;
    font-size: 15px;
    font-weight: 700;
    color: ${(props) => props.theme.color.text.secondary};
    word-break: break-all;
    flex: 1;
  }
`;

// ─── Aviso destacado (ex.: código de verificação vai para o e-mail cadastrado) ─

export const InlineNotice = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px 14px;
  border-radius: 3px;
  background-color: #f794220f;
  border-left: 3px solid ${(props) => props.theme.color.ui.orange};

  svg {
    font-size: 16px;
    color: ${(props) => props.theme.color.ui.orange};
    flex-shrink: 0;
    margin-top: 2px;
  }

  p {
    margin: 0;
    font-family: ${(props) => props.theme.font.body.family};
    font-size: ${(props) => props.theme.font.body.size.small};
    color: ${(props) => props.theme.color.text.tertiary};
    line-height: 1.55;
  }
`;

export const CopyButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 3px;
  border: 1px solid ${(props) => props.theme.color.ui.shade2};
  background: ${(props) => props.theme.color.bg.primary};
  color: ${(props) => props.theme.color.ui.primary};
  font-family: ${(props) => props.theme.font.body.family};
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;

  &:hover {
    opacity: 0.85;
  }
`;

// Quadro do código de verificação da distribuidora no assistente (C2, out/2026)
export const CodePanel = styled.div`
  border: 1px dashed ${(props) => props.theme.color.ui.orange};
  border-radius: 3px;
  padding: 10px 12px;
  margin: 6px 0 10px;

  small {
    display: block;
    color: ${(props) => props.theme.color.text.quaternary};
    font-size: 12px;
  }
`;
